import React from "react";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";

import About from "./About";
import WhatYouWillLearn from "./WhatYouWillLearn";
import CourseContent from "./CourseContent";

const Testimonials = dynamic(
  () => import("./../../../bootcamps/components/common/Testimonials"),
  {
    ssr: false,
  }
);

const MobileDetailSection: React.FC<NSCourses.IDetailSectionProps> = ({
  course,
}) => {
  return (
    <Box>
      {course?.about && (
        <About
          about={course.about}
          courseInstructors={course.course_instructors}
        />
      )}
      <WhatYouWillLearn content={course.what_will_you_learn} />
      <CourseContent
        modules={course.modules}
        userEnrolled={!!course.user_enrolled}
        slug={course.slug}
      />
      <Testimonials />
    </Box>
  );
};

export default MobileDetailSection;
